import { Typography, Tabs, Alert } from 'antd';
import { TagOutlined } from '@ant-design/icons';
import MitigationTypeMapper from '../MitigationTypeMapper';
import MarketIndicatorMapper from '../MarketIndicatorMapper';
import MarketLabelsTab from '../MarketLabelsTab';

const { Title, Text } = Typography;

function MarketIndicatorMitigationMapper() {
  return (
    <div style={{ padding: 24, background: '#f5f5f5', minHeight: '100vh', boxSizing: 'border-box' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginBottom: 0 }}>
          <TagOutlined style={{ marginRight: 8 }} />
          Market labels &amp; Mitigation Type Mapper
        </Title>
        <Text type="secondary">
          Map registry methodologies to market labels, and Calyx project types to mitigation types.
        </Text>
      </div>
      <Alert
        type="info"
        showIcon
        closable
        message="Please note that any changes saved here will not be reflected on the platform immediately. The updates will be applied during the next registry sync, which runs automatically every Saturday."
        style={{ marginBottom: 16 }}
      />
      <Tabs
        defaultActiveKey="market-indicator"
        type="card"
        items={[
          {
            key: 'market-indicator',
            label: 'Market labels Mapping',
            children: <MarketIndicatorMapper />,
          },
          {
            key: 'mitigation-type',
            label: 'Mitigation Type Mapping',
            children: <MitigationTypeMapper />,
          },
          {
            key: 'market-labels',
            label: 'Market labels Metadata',
            children: <MarketLabelsTab />,
          },
        ]}
      />
    </div>
  );
}

export default MarketIndicatorMitigationMapper;
